'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createPayload = exports.normalize = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _adapters = require('./adapters');

var eventAdapters = _interopRequireWildcard(_adapters);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var normalize = exports.normalize = function normalize(identifiers, event) {
  return eventAdapters.applyIdentifiers(identifiers, event);
};

var createPayload = exports.createPayload = function createPayload(_ref, definition, eventProperties, trackerProperties, identifiers) {
  var metaProperties = _ref.metaProperties;

  if (!definition) {
    return null;
  }

  var eventPayload = eventAdapters.transformEventPayload(definition, _extends({}, metaProperties, trackerProperties, eventProperties));

  return eventAdapters.applyIdentifiers(identifiers, eventPayload);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker-core/static-1.70/js/event/index.js
// module id = 389
// module chunks = 0